import {motion} from "framer-motion";
import "./Project.scss";
import React from 'react';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faLongArrowAltLeft} from '@fortawesome/free-solid-svg-icons';
import './../config';

let easing = [0.6, -0.05, 0.01, 0.99];

const stagger = {
    animate: {
        transition: {
            staggerChildren: 0.05
        }
    }
};

const fadeInUp = {
    initial: {
        y: 60,
        opacity: 0,
        transition: {duration: 0.6, ease: easing}
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: easing
        }
    },
    hover: {
        opacity: 0.8,
        x:-10
    },
};

const Project = (props) => {

    const {params} = props.match;
    console.log(params.id);

    return (
        <motion.div initial='initial' animate='animate' exit={{opacity: 0}}>
            <div className='fullscreen'>
                <div className='product'>
                    <motion.div
                        className='img__project'
                        animate={{opacity: 1}}
                        initial={{opacity: 0}}
                        >
                        {/*<motion.img
                            key={require('./../assets/images/wedding.jpg')}
                            src={require('./../assets/images/wedding.jpg')}
                            animate={{x: 0, opacity: 1}}
                            initial={{x: 200, opacity: 0}}
                            exit={{opacity: 0}}
                            transition={{delay: 0.2}}
                        />*/}
                    </motion.div>
                    <div className='product-details'>
                        <motion.div variants={stagger} className='inner'>
                            <Link to={{
                                pathname: '/',
                                query: {
                                    goTo: "gallery"
                                }
                            }}>
                                <motion.div variants={fadeInUp} whileHover="hover">
                                    <FontAwesomeIcon icon={faLongArrowAltLeft} className="icon__back" /><a className='go-back'>Torna indietro</a>
                                </motion.div>
                            </Link>
                            {/*<motion.div variants={fadeInUp}>
                                <span className='category'>Protein</span>
                            </motion.div>*/}
                            <motion.h1 variants={fadeInUp}>{global.config.projects[params.id-1].title}</motion.h1>
                            <motion.p variants={fadeInUp}>{global.config.projects[params.id-1].description}</motion.p>
                            <motion.div variants={fadeInUp} className='additonals'>
                                <p style={{display: "inline", fontSize: "smaller", fontWeight: "bold"}}>CLIENTE: </p><span>{global.config.projects[params.id-1].client}</span>
                                <p style={{display: "inline", fontSize: "smaller", fontWeight: "bold"}}>LUOGO: </p><span>{global.config.projects[params.id-1].place}</span>
                                <p style={{display: "inline", fontSize: "smaller", fontWeight: "bold"}}>ANNO: </p><span>{global.config.projects[params.id-1].year}</span>
                            </motion.div>
                            {/*<motion.div variants={fadeInUp} className='qty-price'>
                                <div className='qty'>
                                    <div className='minus'>-</div>
                                    <div className='amount'>1</div>
                                    <div className='add'>+</div>
                                </div>
                                <span className='price'>Prezzo</span>
                            </motion.div>
                            <motion.div variants={fadeInUp} className='btn-row'>
                                <button className='add-to-cart'> Add to cart</button>
                                <button className='subscribe'> Subscribe</button>
                            </motion.div>*/}
                        </motion.div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
};

export default Project;
